/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { currentPageSurface, trackEvent } from '../lib/gtag';

export const PartnerCTA: React.FC = () => {
  const { t, language } = useLanguage();
  return (
    <section className="bg-slate-900/40 border-t border-slate-800 py-16">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-slate-800/70 border border-slate-700 rounded-3xl p-8 sm:p-10 flex flex-col sm:flex-row gap-6 items-center justify-between shadow-xl shadow-slate-950/30">
          <div className="flex-1 min-w-0 text-center sm:text-left">
            <h3 className="text-2xl font-black text-white">{t('partner_cta.headline')}</h3>
            {/* body_v2 (2026-09-23): the old body sold "werk uw aanbod bij"; its
                value is frozen in i18n_admin on acc and prd, and no tab edited
                it — the Homepage tab has a field for this one. */}
            <p className="text-slate-400 mt-2">{t('partner_cta.body_v2')}</p>
          </div>
          <Link
            to={`/${language}/partner`}
            onClick={() =>
              // surface = WHERE the click happened (the homepage), not where
              // it leads — partner_landing here polluted the /partner segment.
              trackEvent('partner_cta_click', { surface: currentPageSurface(), language })
            }
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-emerald-700 hover:bg-emerald-800 text-white font-bold rounded-2xl transition-all shadow-xl shadow-emerald-900/30 flex-shrink-0 group"
          >
            {t('partner_cta.visit')}
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </Link>
        </div>
      </div>
    </section>
  );
};
